module.exports = __webpack_public_path__ + "static/img/icon1.6b2efae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon1.png
// module id = HWEK
// module chunks = 5